import * as React from "react";
import Header from "../components/Header";
import { makeStyles } from "@fluentui/react-components";
import { LoginButton } from "../components/loginButton";
import "../style.css";
import { BsmapLogin } from "../components/bsmapLogin";
import { BsmapForm } from "../components/bsmapForm";

const useStyles = makeStyles({
  root: {
    minHeight: "100vh",
  },
});

const App: React.FC = () => {
	const styles = useStyles();

	const [msLoginGotten, setMsLoginGotten] = React.useState(false);
	const [bsmapLoginGotten, setBsmapLoginGotten] = React.useState(false);

	const handleMsLoginFinished = () => {
		setMsLoginGotten(true);
	};

	const handleBsmapLoginFinished = () => {
		setBsmapLoginGotten(true);
	};

	React.useEffect(() => {
		console.log(`New app state: {ms:${msLoginGotten}, bsmap:${bsmapLoginGotten}}`);
	}, [msLoginGotten, bsmapLoginGotten])

	return (
		<div className={styles.root}>
			<Header />
			<LoginButton onGet={handleMsLoginFinished} />
			<BsmapLogin onGet={handleBsmapLoginFinished} />
			{bsmapLoginGotten && msLoginGotten && 
				<BsmapForm submitType="setDefault" />
			}
		</div>
	);
};

export default App;
